import { useEffect, useState } from "react";
import { useTimeStore } from "../../stores/time";
import { TextArea } from "../ui/inputs/TextArea";
import { getEventsLabel } from "../../api/timeslabels";
import { Input } from "../ui/inputs/Input";
import { getEvent, postHolidayRequest, updateHolidayRequest } from "../../api/events";
import { showToastError, showToastSuccess } from "../../services/toast";
import { formatDateForInput } from "../../services/function";
import { Select } from "../ui/inputs/Select";
import { getManagers } from "../../api/users";
import { useUserContext } from "../../contexts/userContext";
import { Checkbox } from "../ui/inputs/Checkbox";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const Holidays = ({ closeModal, idEvent }: any) => {
    const {
        formData,
        setFormData,
        resetTime,
        idTimeSelected,
        setIdTimeSelected,
        update,
        setUpdate,
        tab,
      } = useTimeStore();
    const { role } = useUserContext();
    
    const [choiceType, setChoiceType] = useState<any[]>([]);
    const [managers, setManagers] = useState<any[]>([]);

    useEffect(() => {
        getEventsLabel()
        .then((res: any) => {
            setChoiceType(res.data.map((item: any) => ({
                value: item.id,
                label: item.name,
            })));
            
            setFormData({
              idTimesLabel: parseInt(res.data[0].id),
            })
        })
        .catch((err) => {
            console.log(err);
        });

        {role === "Lecteur" && getManagers()
        .then((res: any) => {
            setManagers(res.data.map((item: any) => ({
                value: item.id,
                label: item.firstName + " " + item.lastName,
            })));
        })
        .catch((err) => {
            console.log(err);
        });}
    }, []);

    useEffect(() => {
        if (idEvent !== null || idEvent === undefined && formData.idTimesLabel) {
            getEvent(idEvent)
            .then((res: any) => {
                setFormData({
                    ...res.data,
                    startDate: formatDateForInput(res.data.startDate),
                    endDate: formatDateForInput(res.data.endDate),
                });
            });
        }
    }, [idEvent, formData.idTimesLabel]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Si c'est tout sauf une absence, on vérifie que l'on a au moins un matin, une après-midi ou une journée entière
        if(formData.idTimesLabel !== 15) {
          if(!formData.morning && !formData.afternoon && !formData.isFullDay) {
            return showToastError("Veuillez sélectionner un matin, une après-midi ou une journée entière");
          }
        } 
        if (idEvent !== null || idEvent === undefined) {
            updateHolidayRequest(Number(idEvent), formData)
            .then(() => {
                setFormData({})
                showToastSuccess("La demande de congés a bien été modifiée");
                setUpdate(!update);
                setIdTimeSelected(0);
                closeModal();
            });
        } else {
          postHolidayRequest(formData)
          .then(() => {
            setFormData({})
            showToastSuccess("La demande de congés a bien été ajoutée");
            setUpdate(!update);
            closeModal();
          })
          .catch((err) => {
            if(err.response.data.message === "Chevauchement d'événements pour cette période") {
              return showToastError("Il y a un chevauchement d'événements pour cette période");
            } else {
              showToastError("Une erreur est survenue");
            }
          });
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormData({ ...formData, [e.target.name]: e.target.checked });
    };
    const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setFormData({ ...formData, description: e.target.value });
    };
    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setFormData({ ...formData, [e.target.name]: parseInt(e.target.value) });
    };

    useEffect(() => {
      // Si il y a une matin ou une après-midi, on met isFullDay à false
      if((formData.morning || formData.afternoon) && formData.idTimesLabel !== 15) {
        setFormData({ ...formData, isFullDay: false });
      } 

      // Si cest une journée entière, on enleve les matins et après-midi
      if (formData.isFullDay && formData.idTimesLabel !== 15) {
        setFormData({ ...formData, morning: false, afternoon: false });
      }

      // Si cest une abscence, on enleve les matins et après-midi et on met les heures
      if (formData.idTimesLabel === 15) {
        setFormData({ ...formData, morning: false, afternoon: false });
      }
    }, [formData.morning, formData.afternoon, formData.isFullDay, formData.idTimesLabel])
    
  const handleClose = () => {
    if (tab === "Time") {
      resetTime();
    } else {
      setIdTimeSelected(0);
    }
    setFormData({});
    closeModal();
  };

  return (
    <ModalShell
      title={
        idTimeSelected !== 0
          ? `Modifier la demande de congés / absence`
          : `Ajouter une demande de congés / absence`
      }
      size="md"
      onClose={handleClose}
      footer={
        <>
          <ModalButton variant="secondary" onClick={handleClose}>
            Annuler
          </ModalButton>
          <ModalButton variant="primary" type="submit" form="holidays-form">
            {idTimeSelected !== 0 ? "Modifier" : "Créer"}
          </ModalButton>
        </>
      }
    >
      <div className="grid grid-cols-1 gap-3 font-Nunito sm:grid-cols-2">
        <Select
          label="Type"
          name="idTimesLabel"
          value={formData.idTimesLabel || ""}
          onChange={handleSelectChange}
          fetchOptions={choiceType}
          className="w-full"
        />

        {role === "Lecteur" && (
          <Select
            label="Manager"
            name="idManager"
            onChange={handleSelectChange}
            value={formData.idManager}
            fetchOptions={managers}
            className="w-full cursor-pointer"
          />
        )}
      </div>

      <form
        id="holidays-form"
        onSubmit={handleSubmit}
        className="mt-4 flex flex-col gap-4 font-Nunito"
      >
        {/* Journée(s) entière(s) */}
        <label
          htmlFor="isFullDay"
          className="flex cursor-pointer items-center gap-2.5 text-sm text-slate-600"
        >
          <input
            type="checkbox"
            name="isFullDay"
            id="isFullDay"
            checked={formData.isFullDay || false}
            onChange={handleCheckboxChange}
            className="size-4 cursor-pointer accent-dca-blue"
          />
          Journée(s) entière(s)
        </label>

        <div className="grid grid-cols-1 items-start gap-3 sm:grid-cols-2">
          <Input
            label="Date de début"
            name="startDate"
            type="date"
            required
            value={formData.startDate || ""}
            onChange={handleChange}
            clasName="w-full"
          />
          {!formData.isFullDay && formData.idTimesLabel === 15 && (
            <Input
              label="Heure de début"
              name="startHour"
              type="time"
              value={formData.startHour || ""}
              onChange={handleChange}
              required
              clasName="w-full"
            />
          )}
          {formData.idTimesLabel !== 15 && (
            <Checkbox
              label="Après-midi"
              name="afternoon"
              onChange={handleCheckboxChange}
              checked={formData.afternoon}
              value={formData.afternoon}
              clasName="text-sm"
            />
          )}
        </div>

        <div className="grid grid-cols-1 items-start gap-3 sm:grid-cols-2">
          <Input
            label="Date de fin"
            name="endDate"
            type="date"
            value={formData.endDate || ""}
            onChange={handleChange}
            required
            clasName="w-full"
          />

          {!formData.isFullDay && formData.idTimesLabel === 15 && (
            <Input
              label="Heure de fin"
              name="endHour"
              type="time"
              value={formData.endHour || ""}
              onChange={handleChange}
              required
              clasName="w-full"
            />
          )}
          {formData.idTimesLabel !== 15 && (
            <Checkbox
              label="Matin"
              name="morning"
              onChange={handleCheckboxChange}
              checked={formData.morning}
              value={formData.morning}
              clasName="text-sm"
            />
          )}
        </div>

        <TextArea
          label="Commentaire"
          name="description"
          value={formData.description || ""}
          onChange={handleTextAreaChange}
          clasName="w-full"
        />
      </form>
    </ModalShell>
  );
};

export default Holidays;